import { Component, OnInit, Input, Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../_services/data.service';
import { DateUtilsService } from '../../_services/dateUtils';
import { Config } from '../../_store';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';
  readonly DT_FORMAT = 'dd-MMM-yyyy';
  private monthDict = { '1': 'Jan', '2': 'Feb', '3': 'Mar', '4': 'Apr', '5': 'May', '6': 'Jun', '7': 'Jul', '8': 'Aug', '9': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec' };
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    let formateDate
    if(date){
      if(date.day <= 9 && date.month <=9){
          formateDate = '0'+date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
      if(date.day <= 9 && date.month >= 10 ){
          formateDate = '0'+date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
      if(date.day >= 10 && date.month <=9 ){
          formateDate = date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
      if(date.day >= 10 && date.month >= 10 ){
          formateDate = date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
    }
    else{
      formateDate = '';
    }
    return formateDate
  }
}

@Component({
  selector: 'cheque-detail',
  templateUrl: './cheque-detail.component.html',
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ]
})
export class ChequeDetailComponent implements OnInit {
  chequeDetails: any = {}
  maxDate: any;

  constructor(
    private modal: PopoverController,
    private dataService: DataService,
    private dateUtils: DateUtilsService
  ) { }

  ngOnInit() {
    const current = new Date();
    this.maxDate = {
      day: current.getDate(),
      month: current.getMonth() + 1,
      year: current.getFullYear()
    };
  }

  submitCheque() {
    this.chequeDetails.chqDate = this.dateUtils.getDateFromBootStrapDate(this.chequeDetails.chqDate).format('YYYY-MM-DD');
    this.modal.dismiss(this.chequeDetails)
  }

  close() {
    this.modal.dismiss();
  }

  chequeDateSelected() {
    this.chequeDetails.chequeDate = this.dateUtils.getDateFromBootStrapDate(this.chequeDetails.chqDate).format('YYYY-MM-DD');
  }


}
